import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { SharedServiceConfig } from './shared-service.types';

export function provideSharedService(config: SharedServiceConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: 'sharedServiceConfig', useValue: config }
  ]);
}

export function provideXlsxService(config: SharedServiceConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: 'xlsxServiceConfig', useValue: config }
  ]);
}
